<template>
    <div class="records-container">
        <div class="records-header">
            <div class="header-query">
                <div class="query-item" @click="handleQueryPayDate">
                    <a-icon style="font-size: 14px" type="schedule" />
                    <span class="item-line"></span>
                    <span>{{query.payDate}}</span>
                </div>
                <div class="query-item" @click="handleQueryTag">
                    <a-icon style="font-size: 14px" type="tags" />
                    <span class="item-line"></span>
                    <span>{{query.tag}}</span>
                </div>
            </div>
            <div class="header-report">
                <span>支出：{{records.outcomeMoney}}</span>
                <span>收入：{{records.incomeMoney}}</span>
                <span v-if="query.tag == '全部标签'">结余：{{records.balanceMoney}}</span>
            </div>
        </div>
        <div class="records-content" :style="records.monthVoList && records.monthVoList.length > 0 ? '' : 'background: #fff'">
            <div v-if="records.monthVoList && records.monthVoList.length > 0" class="content-list">
                <div v-for="(monthVo, monthIndex) in records.monthVoList" :key="'month_' + monthIndex">
                    <div v-if="records.hasYear || monthIndex > 0" class="list-item-year">
                        <span class="year-value">{{monthVo.payMonth}}</span>
                        <span>|</span>
                        <span>出：{{monthVo.outcomeMoney}}</span>
                        <span>入：{{monthVo.incomeMoney}}</span>
                        <span v-if="query.tag == '全部标签'">余：{{monthVo.balanceMoney}}</span>
                    </div>
                    <div class="list-item" v-for="(dayVo, dayIndex) in monthVo.dayVoList" :key="'day_' + dayIndex">
                        <div class="item-header">
                            <div class="header-date">{{dayVo.payDay}}</div>
                            <div class="header-count">
                                <span class="count-title">出</span>
                                <span class="count-price" style="margin-right: 15px">{{dayVo.outcomeMoney}}</span>
                                <span class="count-title">入</span>
                                <span class="count-price">{{dayVo.incomeMoney}}</span>
                            </div>
                        </div>
                        <div class="item-list">
                            <div class="list-li" :class="infoVo.payType == '收入' || infoVo.money > 0 ? 'list-li-add' : ''" v-for="(infoVo, infoIndex) in dayVo.infoVoList" :key="'info_' + infoIndex">
                                <div class="li-index">
                                    <a-icon :type="infoVo.tagIcon || 'red-envelope'" theme="filled" />
                                </div>
                                <div class="li-content">
                                    <div class="content-top">
                                        <div class="top-tag">{{infoVo.tag}}</div>
                                        <div class="top-price">{{(infoVo.payType == '收入' || infoVo.money > 0 ? '+' : '') + infoVo.money}}</div>
                                    </div>
                                    <div class="content-info">
                                        <div class="info-time">{{infoVo.payTime}}</div>
                                        <div class="info-line"></div>
                                        <div class="info-remark">{{infoVo.cause}}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div style="height: 500px; position: relative" v-else>
                <empty-box text="暂无收支明细"/>
            </div>
        </div>
        <date-select-drawer ref="date_select_drawer" @select="handleSelectDate"></date-select-drawer>
        <phone-select-drawer ref="select_drawer" @select="handleSelectTag"></phone-select-drawer>
    </div>
</template>

<script>
import phoneSelectDrawer from '@/components/PhoneSelectDrawer'
import DateSelectDrawer from "@/view/mypaymentrecord/components/DateSelectDrawer.vue";
import {getPaymentRecords, getTagOptions} from "@/api/payment";

export default {
    name: "index",
    components: {DateSelectDrawer, phoneSelectDrawer},
    inject: ['setLoading'],
    data() {
        return {
            records: {
                hasYear: false,
                incomeMoney: 0,
                outcomeMoney: 0,
                balanceMoney: 0,
                monthVoList: []
            },
            query: {
                payDate: this.$formatDate(new Date(), 'yyyy年M月'),
                tag: '全部标签',
            }
        }
    },
    watch: {
        query: {
            handler() {
                sessionStorage.setItem('payment_records_query', JSON.stringify(this.query))
            },
            deep: true
        }
    },
    created() {
        const query = sessionStorage.getItem('payment_records_query')
        if (query) {
            this.query = JSON.parse(query)
        }
        this.getRecords()
    },
    methods: {
        getRecords() {
            this.setLoading(true)
            getPaymentRecords({
                date: this.query.payDate,
                tag: this.query.tag == '全部标签' ? '' : this.query.tag,
            }).then(res => {
                this.records = res.data
            }).finally(() => {
                this.setLoading(false)
            })
        },
        handleQueryPayDate() {
            this.$refs['date_select_drawer'].init(this.query.payDate, '请选择日期')
        },
        handleSelectDate(value) {
            this.query.payDate = value
            this.getRecords()
        },
        handleQueryTag() {
            // this.setLoading(true)
            getTagOptions().then(res => {
                const options = [[{
                    label: '全部标签',
                    value: '全部标签',
                }]]
                if (res.data) {
                    const outcomeTagList = res.data['outcomeTagList']
                    if (outcomeTagList && outcomeTagList.length > 0) {
                        options.push([{
                            label: '支出',
                            value: '',
                        }])
                        options.push(outcomeTagList.map(tag => {
                            return {
                                label: tag,
                                value: tag,
                            }
                        }))
                    }
                    const incomeTagList = res.data['incomeTagList']
                    if (incomeTagList && incomeTagList.length > 0) {
                        options.push([{
                            label: '收入',
                            value: '',
                        }])
                        options.push(incomeTagList.map(tag => {
                            return {
                                label: tag,
                                value: tag,
                            }
                        }))
                    }
                }
                this.$refs['select_drawer'].init({
                    key: 'tag',
                    title: '请选择标签',
                    value: this.query.tag,
                    itemCount: 3,
                    options: options
                })
            }).finally(() => {
                // this.setLoading(false)
            })
        },
        handleSelectTag(key, item) {
            this.query[key] = item.value
            this.getRecords()
        }
    }
}
</script>

<style lang="less" scoped>
.records-container {
    .records-header {
        position: fixed;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
        padding: 20px;
        height: 100px;
        background: #3eb375;
        width: 100%;
        max-width: 500px;
        .header-query {
            display: flex;
            .query-item {
                margin-right: 10px;
                background: #51bc83;
                color: #fff;
                padding: 5px 10px;
                border-radius: 2px;
                cursor: pointer;
                user-select: none;
                display: flex;
                align-items: center;
                .item-line {
                    display: inline-block;
                    margin: 0 6px;
                    height: 10px;
                    width: 1px;
                    background: rgba(255,255,255,.4);
                }
            }
        }
        .header-report {
            height: 40px;
            line-height: 40px;
            color: #fff;
            >span {
                padding-left: 8px;
            }
        }
    }
    .records-content {
        padding: 110px 10px 80px 10px;
        background: #EBEBECFF;
        box-sizing: border-box;
        min-height: 100vh;
        .content-list {
            width: 100%;
            .list-item {
                margin-bottom: 10px;
                .item-header {
                    height: 60px;
                    line-height: 40px;
                    background: #f9f9fa;
                    border-radius: 6px 6px 0 0;
                    padding: 10px 20px;
                    box-sizing: border-box;
                    display: flex;
                    justify-items: center;
                    justify-content: space-between;
                    .header-date {
                        font-size: 16px;
                    }
                    .header-count {
                        .count-title {
                            background: #f1f1f2;
                            padding: 3px 5px;
                            border-radius: 3px;
                            margin-right: 5px;
                        }
                        .count-price {
                            font-size: 16px;
                        }
                    }
                }
                .item-list {
                    background: #fff;
                    border-radius: 0 0 6px 6px;
                    .list-li {
                        display: flex;
                        height: 80px;
                        padding: 20px 0 0 20px;
                        .li-index {
                            line-height: 40px;
                            text-align: center;
                            width: 40px;
                            height: 40px;
                            font-size: 18px;
                            border-radius: 50%;
                            color: #fff;
                            background: #3eb475;
                        }
                        .li-content {
                            width: calc(100% - 40px);
                            display: flex;
                            flex-direction: column;
                            border-bottom: 1px solid #f1f1f2;
                            padding: 0 20px 0 10px;
                            .content-top {
                                display: flex;
                                width: 100%;
                                justify-content: space-between;
                                font-size: 16px;
                                .top-price {
                                    font-weight: bold;
                                }
                            }
                            .content-info {
                                color: #c5c5c6;
                                display: flex;
                                align-items: center;
                                line-height: 25px;
                                .info-line {
                                    margin: 0 6px;
                                    height: 10px;
                                    width: 1px;
                                    background: #c5c5c6;
                                }
                                .info-remark {
                                    overflow: hidden;
                                    white-space: nowrap;
                                    text-overflow: ellipsis;
                                }
                            }
                        }
                        &:last-child {
                            .li-content {
                                border-bottom: none;
                            }
                        }
                    }
                    .list-li-add {
                        .li-index {
                            background: #eeb63b;
                        }
                        .top-price {
                            color: #eeb63b;
                        }
                    }
                }
            }
            .list-item-year {
                margin-bottom: 10px;
                color: #a8a8a9;
                >span {
                    padding-left: 5px;
                }
                .year-value {
                    padding-left: 10px;
                    color: #757576;
                }
            }
        }
    }
}

</style>
